import { LocalStorageKey } from '@diritto/common/utils/localStorage';
import { useEffect, useState } from 'react';
import { LocalStorage } from 'utils/LocalStorage';
import { ReplyOrder } from '@diritto/common/reply/constants';

export const useReplyOrderType = ({
  initialOrderType,
  defaultValue = ReplyOrder.Like,
}: {
  initialOrderType?: ReplyOrder;
  defaultValue?: ReplyOrder;
}) => {
  const key = LocalStorageKey.EpisodeReplyOrder;
  const [orderType, setOrderType] = useState(initialOrderType || defaultValue);

  useEffect(() => {
    const savedOrderType = LocalStorage.getItem(key as LocalStorageKey) as ReplyOrder;
    if (savedOrderType) {
      setOrderType(savedOrderType);
    }
  }, [key]);

  useEffect(() => {
    if (initialOrderType) {
      LocalStorage.setItem(key as LocalStorageKey, initialOrderType);
      setOrderType(initialOrderType);
    }
  }, [initialOrderType, key]);

  return { orderType, setOrderType };
};
